import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export const SUPPORT_EMAIL = "support@mypayalert.com";

export function LegalShell({ title, subtitle, updated, children }) {
  return (
    <div className="min-h-screen bg-[#080d1a] text-slate-300">
      <header className="border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-logo">
            <div className="h-8 w-8 rounded-lg bg-blue-600 flex items-center justify-center"><ShieldCheck className="h-4 w-4 text-white" /></div>
            <span className="text-white font-black">MyPayAlert</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors" data-testid="legal-back-home">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-slate-400 mt-3 text-base">{subtitle}</p>}
        {updated && <p className="text-xs text-slate-500 mt-4">Last updated: {updated}</p>}
        <div className="mt-8 space-y-8 leading-relaxed text-[15px]">{children}</div>
      </main>

      <footer className="border-t border-white/5 py-6 text-center text-xs text-slate-500">
        © 2026 MyPayAlert. All rights reserved. · <Link to="/privacy" className="hover:text-white">Privacy</Link> · <Link to="/terms" className="hover:text-white">Terms</Link> · <Link to="/contact" className="hover:text-white">Contact</Link>
      </footer>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-white mb-2">{heading}</h2>
      <div className="space-y-3 text-slate-400">{children}</div>
    </section>
  );
}
